import { IActivity, ICourse, IQuestion, ISection } from '@sdk/contracts';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import {
  AnswersList,
  ResourceContainerWrapper,
  ResourceContentWrapper,
  ResourceTitleWrapper
} from './ProblemReportsTitle.styles';

import { ActivityForm } from '@/components/ActivityForm';
import { ActivityPreview } from '@/components/ActivityPreview';
import { useActivityPreview, useManualQuestionForm } from '@/hooks';
import { useActivityForm, useProfile } from '@/store';

type Props = {
  resource?: IActivity | IQuestion;
  course: ICourse;
  section?: ISection;
};

export const ProblemReportTitle: React.FC<Props> = ({ resource, course, section }) => {
  const { t } = useTranslation('ProblemReportsTranslations');
  const { t: tDefault } = useTranslation('DefaultTranslations');
  const {
    roleCheck: { isManager }
  } = useProfile();
  const { setQuestion } = useManualQuestionForm();
  const { setActivityId } = useActivityPreview();
  const { setCourse, setData, setSectionId, setIsOpen: setActivityFormOpen } = useActivityForm();

  if (!resource) return null;
  const isQuestion = 'title' in resource;
  const isActivity = 'name' in resource;

  const onClickQuestionDetail = () => {
    if (isQuestion) setQuestion(resource);
  };

  const onClickActivityDetail = () => {
    if (!isActivity) return;

    if (isManager) {
      setCourse(course);
      setData(resource);
      setSectionId(section?._id);
      setActivityFormOpen(true);
    } else {
      setActivityId(resource._id);
    }
  };

  if (isQuestion)
    return (
      <ResourceContainerWrapper>
        <div>
          <ResourceTitleWrapper>{t('QUESTION')}</ResourceTitleWrapper>
          <ResourceContentWrapper>{resource.title}</ResourceContentWrapper>
        </div>
        <div>
          <ResourceTitleWrapper>{t('QUESTION_ANSWERS')}</ResourceTitleWrapper>
          <AnswersList>
            {resource.answers.map(a => (
              <li key={a.text}>{a.text}</li>
            ))}
          </AnswersList>
        </div>
        <div>
          <Button type="primary" onClick={onClickQuestionDetail}>
            {tDefault('EDIT_QUESTION')}
          </Button>
        </div>
      </ResourceContainerWrapper>
    );
  if (isActivity) {
    const sectionName = section?.name;

    return (
      <ResourceContainerWrapper>
        <div>
          <ResourceTitleWrapper>{t('COURSE')}</ResourceTitleWrapper>
          <ResourceContentWrapper>{course.name}</ResourceContentWrapper>
        </div>
        {sectionName && (
          <div>
            <ResourceTitleWrapper>{t('SECTION')}</ResourceTitleWrapper>
            <ResourceContentWrapper>{sectionName}</ResourceContentWrapper>
          </div>
        )}
        <div>
          <ResourceTitleWrapper>{t('ACTIVITY')}</ResourceTitleWrapper>
          <ResourceContentWrapper>{resource.name}</ResourceContentWrapper>
        </div>
        <div>
          <ResourceTitleWrapper>{t('DESCRIPTION')}</ResourceTitleWrapper>
          <ResourceContentWrapper>{resource.description}</ResourceContentWrapper>
        </div>
        <div>
          <Button type="primary" onClick={onClickActivityDetail}>
            {isManager ? tDefault('EDIT_ACTIVITY') : tDefault('VIEW_ACTIVITY')}
          </Button>
        </div>
        {isManager ? <ActivityForm /> : <ActivityPreview />}
      </ResourceContainerWrapper>
    );
  }

  return null;
};
